// If phones changes check for phone use in: data/romanian/articles all | in:
const dataGeneralInfo = {
  address: '31 august, Drochia, Moldova',
  phone1: {
    label: '+373 676 17 827',
    action: 'tel:+37367617827'
  },
  phone2: {
    label: '+373 676 17 284',
    action: 'tel:+37367617284'
  },
  email: {
    label: 'marik1988@gmail.com',
    action: 'mailto:marik1988@gmail.com'
  },
  social: {
    facebook: 'https://www.facebook.com/cameliafloridrochia',
    insta: 'https://www.instagram.com/bloom_your_life/'
  }
};

export default dataGeneralInfo;
